import PaginationResponse from "@/interfaces/responses/PaginationResponse";
import Dataset from "./Dataset";
import DatasetVersion from "./DatasetVersion";

export default class DatasetWithVersions {
  public dataset: Dataset;
  public versions: PaginationResponse<DatasetVersion[]>;
}
